import React, { CSSProperties, useEffect, useState } from 'react'
import styled from 'styled-components'
import { ReactComponent as Feat1 } from 'ASSETS/svg/icon_feat_1.svg'
import feat1Img from 'ASSETS/png/feat1.png'

const FeatContainer1 = () => {
  const [size, setSize] = useState(120)
  const [left, setLeft] = useState(50)
  const [quality, setQuality] = useState(0.4)
  const [radius, setRadius] = useState(12)
  const [color, setColor] = useState('unset')

  const init = () => {
    setSize(122)
    setLeft(50)
    setQuality(0.4)
  }

  const start = () => {
    setRadius(14)
  }
  useEffect(() => {
    if (radius === 14) {
      window.requestAnimationFrame(() => {
        if (quality < 0.6) {
          setQuality((quality) => quality + 0.01)
        } else {
          setQuality(0.6)
        }
      })
    }
  }, [quality, radius])

  useEffect(() => {
    if (quality === 0.6) {
      setRadius(12)
      window.requestAnimationFrame(() => {
        if (left < 300) {
          setLeft((left) => left + 6)
        } else {
          setLeft(300)
        }
      })
    }
  }, [quality, left])

  useEffect(() => {
    if (quality === 0.6) {
      setColor('black')
      window.requestAnimationFrame(() => {
        if (size > 40) {
          setSize((size) => size - 2)
        } else {
          setColor('unset')
          setSize(40)
        }
      })
    }
  }, [quality, size])

  useEffect(() => {
    if (left === 300) {
      setTimeout(() => {
        init()
        start()
      }, 2000)
    }
  }, [left])

  useEffect(() => {
    start()
  }, [])

  return (
    <Container>
      <IconFeat1></IconFeat1>
      <div style={{ width: '144px', alignSelf: 'flex-start', marginTop: '24px' }}>
        <FeatTitle>支持</FeatTitle>
        <FeatActiveTitle>高压缩 </FeatActiveTitle>
        <FeatTitle>图片格式转化</FeatTitle>
      </div>
      <FeatContent>
        保证图片视觉效果无损的基础上，支持转化为 HEIF 等高压缩图片格式，相比 WebP 体积小
        30%，在保持画质不变的前提下，节省更多成本。
      </FeatContent>
      <Feat1Cube></Feat1Cube>
      <Feat1ImgContainer>
        <img src={feat1Img} style={{ borderRadius: '12px' }}></img>
        <Feat1Mask style={{ backgroundColor: color }}></Feat1Mask>
        <Feat1Tag style={{ width: '113px', left: '15px', top: '15px' }}>
          原图 5MB
        </Feat1Tag>
        <Feat1Tag
          style={{ width: '154px', right: '15px', top: '15px' }}
        >{`ImageX ${size}KB`}</Feat1Tag>
        <Slider
          style={{
            height: '338px',
            left: `${left - 13.5}px`,
            opacity: quality === 0.6 ? '1' : '0',
          }}
        ></Slider>
        <QualityContainer>
          <QualityText>压缩质量</QualityText>
          <QualityBoldText>{`${Math.round(quality * 100)}%`}</QualityBoldText>
          <QualitySlider>
            <QualityLine style={{ width: `${430 * quality}px` }}>
              <QualityCircle
                style={{
                  left: `${430 * quality}px`,
                  width: `${radius * 2}px`,
                  height: `${radius * 2}px`,
                  borderRadius: `${radius}px`,
                }}
              ></QualityCircle>
            </QualityLine>
          </QualitySlider>
        </QualityContainer>
      </Feat1ImgContainer>
    </Container>
  )
}

const Container = styled.div`
  width: 343px;
  display: flex;
  height: 598px;
  flex-direction: column;
  align-items: center;
  position: relative;
`

const IconFeat1 = styled(Feat1)`
  margin-top: 40px;
  align-self: flex-start;
  width: 40px;
  height: 40px;
  box-shadow: 1px 4px 20px rgba(184, 213, 240, 0.3);
  border-radius: 20px;
`

const FeatTitle = styled.span`
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 34px;
  color: #282f38;
`

const FeatActiveTitle = styled(FeatTitle)`
  color: #3370ff;
`

const FeatContent = styled.div`
  width: 323px;
  margin: 16px 0 32px 0;
  align-self: flex-start;
  font-size: 14px;
  line-height: 22px;
  color: #4e5969;
  opacity: 0.8;
`

const Feat1Cube = styled.div`
  width: 258px;
  height: 248px;
  background: #f1f7ff;
  border-radius: 6px;
  align-self: flex-end;
`

const Feat1ImgContainer = styled.div`
  position: absolute;
  top: 306px;
  width: 600px;
  height: 338px;
  box-shadow: 0px -1.22909px 3.68727px rgba(111, 123, 169, 0.1),
    0px 122.909px 98.3273px rgba(217, 225, 250, 0.17),
    0px 33.6884px 9.81248px rgba(193, 198, 215, 0.127269);
  border-radius: 12px;
  pointer-events: none;
  background-color: transparent;
  transform: scale(0.5);
  transform-origin: top;
`

const Feat1Tag = styled.div`
  height: 36px;
  background: rgba(255, 255, 255, 0.4);
  border-radius: 2.45818px;
  position: absolute;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #000000;
  opacity: 0.5;
`

const SliderContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 3;
  display: flex;
  align-items: center;
  pointer-events: none;
`

const SliderLine = styled.div`
  height: 320px;
  width: 3px;
  background: white;
  margin: 0 3px;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.16);
  transform: translateY(-9px);
`

const Triangle = styled.div`
  width: 0;
  height: 0;
  border-left: 4.5px solid white;
  border-right: 4.5px solid transparent;
  border-top: 4.5px solid transparent;
  border-bottom: 4.5px solid transparent;
  filter: drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.16));
`

const Slider = (props: { style?: CSSProperties }) => {
  return (
    <SliderContainer draggable={false} style={props.style}>
      <Triangle style={{ transform: 'rotate(180deg)' }} />
      <SliderLine></SliderLine>
      <Triangle />
    </SliderContainer>
  )
}

const QualityContainer = styled.div`
  position: absolute;
  width: 480px;
  height: 96px;
  left: 60px;
  top: 320px;

  filter: drop-shadow(0px 80px 64px rgba(193, 198, 215, 0.17));
  border-radius: 8px;
  z-index: 99;
  background: rgba(252, 250, 252, 0.9);
  backdrop-filter: blur(6px);
`

const QualityText = styled.div`
  position: absolute;
  width: 72px;
  height: 18px;
  left: 24px;
  top: 20px;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 18px;
`

const QualityBoldText = styled(QualityText)`
  left: unset;
  right: 24px;
  top: 20px;
  font-weight: 600;
  text-align: right;
`

const QualitySlider = styled.div`
  position: absolute;
  top: 64px;
  right: 24px;
  width: 430px;
  height: 4px;
  background: #e6e8eb;
  border-radius: 3.2px;
`

const QualityLine = styled.div`
  height: 100%;
  background: #3370ff;
  border-radius: 3.2px 0 0 3.2px;
  position: relative;
`

const QualityCircle = styled.div`
  background: #ffffff;
  border: 5px solid #3370ff;
  box-sizing: border-box;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.14);
  position: absolute;
  width: 24px;
  height: 24px;
  border-radius: 12px;
  transform: translateY(-50%);
  top: 50%;
  transition: border-radius ease 0.2s;
`

const Feat1Mask = styled.div`
  transition: all ease 0.2s;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.1;
  border-radius: 12px;
`

export default FeatContainer1
